import {usePdf} from "./UsePdf"

const PdfJs = (props) => {
  let texts = {
    en: {
      nextPage: "Next page",
      prevPage: "Previous page",
      zoomIn: "Zoom in",
      zoomOut: "Zoom out",
      download: "Download"
    },
    cs: {
      nextPage: "Další stránka",
      prevPage: "Předchozí stránka",
      zoomIn: "Zvětšit",
      zoomOut: "Zmenšit",
      download: "Stáhnout"
    },
    sk: {
      nextPage: "Ďalšia stránka",
      prevPage: "Predchádzajúca stránka",
      zoomIn: "Priblíženie",
      zoomOut: "Oddialenie",
      download: "Stiahnuť"
    }
  }

  let field = props.data
  const [file, setFile] = React.useState(null)
  const [page, setPage] = React.useState(1)
  const [percent, setPercent] = React.useState({percent: null, percentTxt: 100})
  const canvasRef = React.useRef([])
  let multi = MC.getFieldParamBooleanValue(field.param, '@multiPage')
  const {pdfDocument, pdfPage} = usePdf({file, page: multi ? 'all' : page, canvasRef, scale: percent.percent ? percent.percent/100 : null, baseUrl: field.flow.baseUrl})

  React.useEffect(() => {
    if (!pdfDocument || percent.percent) return
    const scaleTo100 = MC.getFieldParamBooleanValue(field.param, '@scaleTo100')
    if (scaleTo100) {
      setPercent({percent: 100, percentTxt: 100})
      return
    }
    pdfDocument.getPage(1).then(page => {
      const viewport = page.getViewport({scale: 1.0})
      const requiredWidth = canvasRef.current[0]?.parentElement?.clientWidth || 0
      const p = requiredWidth ? Math.floor((requiredWidth / viewport.width) * 100) : 100
      setPercent({percent: p, percentTxt: p})
    })
  }, [pdfDocument])

  React.useEffect(() => {
    let uri = MC.getFieldParamValue(field.param, '@url')
    const value = MC.getFieldParamValue(field.param, 'value')
    if (!MC.isNull(uri)) {
      uri =  MC.rebaseUrl(field.flow, uri)
    } else if (!MC.isNull(value)) {
      uri = 'data:application/pdf;base64,' + value
    }
    setFile(uri)
  }, [props])

  const changePercentValue = (e) => {
    setPercent({percent: percent.percent, percentTxt: e.target.value.replace(/\D/g, '')})
  }

  const blurPercent = (e) => {
    updatePercent(parseInt(e.target.value))
  }

  const updatePercent = (newPercent) => {
    if (newPercent < 10) {
      newPercent = 10
    }
    if (newPercent > 500) {
      newPercent = 500
    }
    setPercent({percent: newPercent, percentTxt: newPercent})
  }

  const download = () => {
    const a = document.createElement('a')
    a.href = file
    a.download = MC.getFieldParamValue(field.param, '@fileName')
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  }

  const _t = (source) => {
    return texts[field.flow.lang][source]
  }
  
  let cssclass = MC.getFieldParamValue(field.param, '@cssClass')
  let css = MC.styleObjectFromString(MC.getFieldParamValue(field.param, '@css'))
  let downloadButt = MC.getFieldParamBooleanValue(field.param, '@downloadButton')
  let pagesToRender = multi ? pdfDocument?.numPages : 1
  return (
    <div className={cssclass} width="100%" style={{...css, border: '1px solid var(--mnc-outline-variant2-color, \'#CED5DB\''}} data-widget-i-name={field.id}>
      {Boolean(pdfDocument && pdfDocument.numPages) && (  
        <div style={{backgroundColor: 'var(--mnc-surface-color, \'#F8F9FB\')', borderBottom: '1px solid var(--mnc-outline-variant2-color, \'#CED5DB\'', padding: '3px'}}>
          {!multi && (
            <React.Fragment>
              <div className="mnc icon buttons">
                <button className="mnc icon button" title={_t('prevPage')} disabled={page === 1} onClick={() => setPage(page - 1)}>
                  <i className="mnc icon angle up"/>
                </button>
                <button className="mnc icon button"  title={_t('nextPage')} disabled={page === pdfDocument.numPages} onClick={() => setPage(page + 1)}>
                  <i className="mnc icon angle down"/>
                </button>
              </div>
              <span style={{marginRight: '.5em'}}>{page}/{pdfDocument.numPages}</span>
            </React.Fragment>
          )}
          <div className="mnc icon buttons">
            <button className="mnc icon button" title={_t('zoomOut')}  disabled={percent.percent <= 10} onClick={() => updatePercent(percent.percent - 10)}>
              <i className="mnc icon minus"/>
            </button>
            <input type="text" min="10" max="500" style={{width: '70px'}} value={percent.percentTxt + '%'} onBlur={blurPercent} onChange={changePercentValue} onKeyUp={(e) => { if (e.key == 'Enter') blurPercent(e) }} />
            <button className="mnc icon button" title={_t('zoomIn')} disabled={percent.percent >= 500}  onClick={() => updatePercent(percent.percent + 10)}>
              <i className="mnc icon plus"/>
            </button>
          </div>
          {downloadButt && (
            <button className="mnc icon button" title={_t('download')} onClick={download}>
              <i className="mnc icon download"/>
            </button>
          )}
        </div>  
      )}
      <div width="100%" style={{overflow: 'auto', textAlign: 'center', backgroundColor: 'var(--mnc-surface-color, \'#F8F9FB\')', height: MC.getFieldParamValue(field.param, '@height')}}>
        {Array(pagesToRender).fill().map((item, i) => <canvas key={i} ref={(el) => canvasRef.current[i] = el} style={{display: 'block', marginLeft: 'auto', marginRight: 'auto', marginTop: '5px',  marginBottom: '5px'}}/>)}
      </div>
    </div>
  )
}

MC.registerReactRomponent('pdfjs', PdfJs)